<main class="about-page">
  <section class="about-hero">
    <div>
      <p class="eyebrow">ABOUT {{ appName | uppercase }}</p>
      <h1>Conversations that begin naturally.</h1>
      <p class="about-lede">
        {{ appName }} is a modern platform for spontaneous one-to-one text
        conversations with people around the world. Meet someone new, share a
        thought, or simply spend a few meaningful minutes without complicated
        setup.
      </p>
      <a class="primary-button" routerLink="/chat">Start a conversation </a>
    </div>
    <div class="about-orbit" aria-hidden="true">
      <span class="orbit-core">S</span><span class="orbit-dot dot-one">M</span
      ><span class="orbit-dot dot-two">J</span
      ><span class="orbit-dot dot-three">A</span>
    </div>
  </section>

  <section class="about-section split-section">
    <div>
      <p class="eyebrow">WHY WE EXIST</p>
      <h2>A place where conversations begin without a performance.</h2>
    </div>
    <div>
      <p>
        People come to {{ appName }} from different countries, cultures, and
        perspectives. Every interaction is different because every person is
        different.
      </p>
      <p>
        We focus on spontaneous conversations, meeting people outside your usual
        circle, friendly exchanges across cultures, and discovering viewpoints
        you would not find in your regular feed.
      </p>
    </div>
  </section>

  <section class="about-section feature-band">
    <div>
      <p class="eyebrow">SIMPLE, INSTANT, HUMAN</p>
      <h2>No endless profiles. Just a better first hello.</h2>
    </div>
    <div class="about-points">
      <article>
        <strong>01</strong>
        <h3>Start quickly</h3>
        <p>
          Choose a nickname, add interests if you like, and enter a text
          conversation in seconds.
        </p>
      </article>
      <article>
        <strong>02</strong>
        <h3>Stay anonymous</h3>
        <p>
          You decide what to share. {{ appName }} does not require a public
          profile to begin.
        </p>
      </article>
      <article>
        <strong>03</strong>
        <h3>Switch when needed</h3>
        <p>
          Skip, block, or report a conversation whenever it stops feeling right.
        </p>
      </article>
    </div>
  </section>

  <section class="about-section safety-section">
    <div>
      <p class="eyebrow">DESIGNED WITH SAFETY IN MIND</p>
      <h2>Comfort and control are part of the product.</h2>
    </div>
    <div>
      <p>
        Anonymous conversations require clear boundaries. {{ appName }} gives
        you simple controls for leaving a chat, skipping a match, blocking a
        user, and reporting harmful behavior.
      </p>
      <ul>
        <li>Easy disconnect at any time</li>
        <li>Session-scoped block and report actions</li>
        <li>Interest preferences without public profiles</li>
        <li>Privacy-conscious guest access</li>
      </ul>
      <a class="text-link" routerLink="/safety">Read our safety guidance </a>
    </div>
  </section>

  <section class="about-section roadmap-section">
    <p class="eyebrow">WHAT COMES NEXT</p>
    <h2>Text chat today. More ways to connect over time.</h2>
    <p>
      {{ appName }} currently focuses on anonymous text chat and interest-based
      matching. We are exploring future voice and video experiences carefully,
      with safety and user control shaping every step.
    </p>
    <div class="roadmap-tags">
      <span>Live now · Text chat</span><span>Exploring · Voice chat</span
      ><span>Exploring · Video chat</span>
    </div>
  </section>

  <section class="about-section mission-section">
    <p class="eyebrow">OUR MISSION</p>
    <h2>
      Make it easier for people anywhere to connect, converse, and discover each
      other in a genuine way.
    </h2>
    <p>
      In a world of curated feeds and algorithm-driven content, we want to make
      room for real, unscripted conversations that start with something as
      simple as hello.
    </p>
    <a class="primary-button" routerLink="/blog">Explore the journal </a>
  </section>

  <section class="about-contact">
    <h2>Have a question or idea?</h2>
    <p>We value thoughtful feedback from the people using {{ appName }}.</p>
    <a routerLink="/contact">Contact {{ appName }} </a>
  </section>
</main>
